// Compiled at 2026-05-13T13:50:05.286Z
export let $ = null;
